module.exports = __webpack_public_path__ + "img/taiyo_cursor_hover_click.12090536.png";